export default {
    ERROR: {
        "code": 0,
        "level": "error"
    },
    SUCCESS: {
        "code": 1,
        "level": "success"
    },
    MISSING_JOB_HISTORY_LINK: {
        "code": 2,
        "level": "error"
    },

    INVOICE_ALREADY_DELETED: {
        "code": 3,
        "level": "error"
    }
}




// WEBPACK FOOTER //
// ./src/enums/InvoiceCheckStatus.js